import React from "react";

import type { ProcessedBetEntry } from "@/hooks/firestore/betting/useEntries";

import cx from "classnames";
import { isPast } from "date-fns/isPast";
import { parseISO } from "date-fns/parseISO";
import { CashOutIcon, Clamp, Live } from "@picklebet/ui";
import { Countdown } from "@/features/shell/components/shared/Countdown";
import {
  getEntryStatus,
  isEntryCashedOut,
  isEntryDecided,
} from "../../util/entry-helpers";
import { WinCelebration } from "../common/WinCelebration";

import * as styles from "./BetEntryClamp.module.scss";

interface BetEntryClampProps {
  entry: ProcessedBetEntry;
}

const BetEntryClamp = ({ entry }: BetEntryClampProps) => {
  const isCashedOut = isEntryCashedOut(entry);
  const decided = isEntryDecided(entry);
  const isEntryWon = entry.data.result === "WIN";
  const [text, variant] = getEntryStatus(entry);
  const isLive =
    entry.data.status === "LIVE" ||
    isPast(parseISO(entry.scheduledStartTime ?? ""));

  if (decided) {
    return (
      <div className={styles.clamp}>
        <Clamp
          variant={variant}
          className={cx({
            [styles.cashout]: isCashedOut,
          })}
        >
          <WinCelebration isEnabled={isEntryWon}>
            {isCashedOut ? <CashOutIcon className={styles.cashout} /> : null}
            {text}
          </WinCelebration>
        </Clamp>
      </div>
    );
  }

  if (!isLive && !decided) {
    return (
      <div className={styles.clamp}>
        <Countdown
          scheduledStartTime={parseISO(entry.scheduledStartTime ?? "")}
        />
      </div>
    );
  }

  return (
    <div className={styles.clamp}>
      <Live />
    </div>
  );
};

export { BetEntryClamp };
